import { Component } from 'react';
import type { PropsWithChildren, ReactNode } from 'react';

import { ThemeRegistry } from 'src/features/config/ThemeRegistry';

// The platform theme sources are lazy chunks. If one fails to load (stale index.html after a
// deploy, flaky connectivity), render the page in the default light theme instead of a blank
// screen: the error pages are exactly where the app is already in trouble.
// `children` is the themed tree (containing the lazy chunk); `page` is the bare page, rendered
// on its own when that tree fails.
export class ThemeLoadFallback extends Component<
  PropsWithChildren<{ page: ReactNode }>,
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    return this.state.failed ? (
      <ThemeRegistry forceTheme="light">{this.props.page}</ThemeRegistry>
    ) : (
      this.props.children
    );
  }
}
